import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO: relay to set the edited params to match the applied params
 */
export const startEditingParams = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.startEditingParams.relay(forwardTo =>
      rxjs
        .combineLatest({
          descending: plugin.appliedParams.selectors.descending.asObservable,
          filters: plugin.appliedParams.selectors.filters.asObservable,
          quantity: plugin.appliedParams.selectors.quantity.asObservable,
          search: plugin.appliedParams.selectors.search.asObservable,
          skip: plugin.appliedParams.selectors.skip.asObservable,
          sortBy: plugin.appliedParams.selectors.sortBy.asObservable,
        })
        .pipe(
          rxjs.take(1),
          rxjs.map(values =>
            forwardTo(plugin.editedParams.actions.writeAllProperties, {
              input: { values },
            }),
          ),
        ),
    ).asObservable,
)
